// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"18495d4c","598":"dffaeb9a","703":"ebbf1c75"}[chunkId] + ".chunk.js";
};